declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
    hideCrisp: () => void;
    showCrisp: () => void;
  }
}

export function initCrispChat() {
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID ?? "";

  (() => {
    var d = document;
    var s = d.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    // @ts-expect-error
    s.async = 1;
    d.getElementsByTagName("head")[0].appendChild(s);
  })();

  window.$crisp.push(["safe", true]);
}

let suppressed = false;

// Lets a page (e.g. the configurator) keep Crisp hidden even when other code
// (modal close, etc.) tries to show it.
export function setCrispSuppressed(value: boolean) {
  suppressed = value;
  if (value) {
    hideCrispChat();
  } else {
    showCrispChat();
  }
}

export function showCrispChat() {
  if (suppressed) {
    return;
  }
  if (window.$crisp) {
    window.$crisp.push(["do", "chat:show"]);
  } else if (process.env.IS_PRODUCTION_ENV === "true") {
    console.error("Crisp not yet initialized.");
  }
}

export function hideCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(["do", "chat:hide"]);
  } else if (process.env.IS_PRODUCTION_ENV === "true") {
    console.error("Crisp is not yet initialized.");
  }
}
